import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';

function imageCarouselContained() {
  const carouselElements = document.querySelectorAll('.media-carousel-swiper');
  const isLandingPage = document.body.classList.contains('page-node-type-landing-page');

  if (!carouselElements.length > 0) return;

  carouselElements.forEach((el) => {
    const swiperEl = el.querySelector('.swiper:not(.no-swiper)');
    const btnNext = el.querySelector('.swiper-button-next');
    const btnPrev = el.querySelector('.swiper-button-prev');
    const captionContainer = el.querySelector('[data-caption-container]');
    const parentIsLeftColumn = el.closest('.page-left-column');
    const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
    const slides = el.querySelectorAll('.swiper-slide');
    const originalSlidesCount = slides.length;

    // Extract captions from original slides before any duplication
    const captions = [];
    slides.forEach((slide) => {
      const captionEl = slide.querySelector('.media-caption');
      if (captionEl) {
        captions.push(captionEl.innerHTML.trim());
      } else {
        captions.push('');
      }
    });

    // Duplicate slides if we have exactly 3 to enable smooth looping
    if (originalSlidesCount === 3) {
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        swiperWrapper.appendChild(clone);
      });
    }

    // Hide all captions in slides (including duplicates)
    el.querySelectorAll('.swiper-slide .media-caption').forEach((captionEl) => {
      captionEl.style.display = 'none';
    });

    const isLoop = originalSlidesCount >= 3;

    // Function to update caption
    function updateCaption(index) {
      if (captionContainer && captions.length > 0) {
        const realIndex = isLoop ? index % captions.length : index;
        captionContainer.innerHTML = captions[realIndex];

        // Toggle visibility class
        if (captions[realIndex]) {
          captionContainer.classList.add('is-visible');
        } else {
          captionContainer.classList.remove('is-visible');
        }
      }
    }

    // default breakpoints
    const defaultBreakpoints = {
      768: { slidesPerView: 1.2, spaceBetween: 24 },
      1200: { slidesPerView: isLandingPage ? 1.2 : 1.85, spaceBetween: 24 },
      1920: { slidesPerView: isLandingPage ? 1.45 : 1.85, spaceBetween: 24 },
    };

    // Breakpoints for .page-left-column only
    const leftColumnBreakpoints = {
      768: { slidesPerView: 1, spaceBetween: 24 },
      1200: { slidesPerView: 1, spaceBetween: 24 },
    };

    // Choose breakpoints based on condition
    const breakpoints = parentIsLeftColumn ? leftColumnBreakpoints : defaultBreakpoints;

    const swiper = new Swiper(swiperEl, {
      direction: 'horizontal',
      allowTouchMove: true,
      loop: isLoop,
      a11y: true,
      keyboard: {
        enabled: true,
      },
      autoHeight: false,
      centeredSlides: true,
      slidesPerView: parentIsLeftColumn ? 1 : 1.2,
      spaceBetween: 16,
      speed: 600,
      modules: [Navigation, Autoplay],
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: breakpoints,
      on: {
        init: function () {
          // Set initial caption
          updateCaption(this.realIndex);
        },
        slideChange: function () {
          // Update caption on slide change
          updateCaption(this.realIndex);
        },
      },
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  imageCarouselContained();
});
